import { SelectField, SelectFieldProps } from 'components/form'
import { ParteBucalEnum } from 'graphql/types.generated'
import React from 'react'

import { getTecidosMolesParteBucal, getTecidosMolesPartesBucais } from '../model'

export interface LocalTecidosMolesFieldModel {
  value: ParteBucalEnum
  label: string
}

export interface LocalTecidosMolesFieldProps
  extends Omit<SelectFieldProps<LocalTecidosMolesFieldModel>, 'label' | 'itemToString' | 'items'> {}

export default function LocalTecidosMolesField(props: LocalTecidosMolesFieldProps) {
  return <SelectField label='Local' items={items} itemToString={(i) => i?.label} {...props} />
}

const items = getTecidosMolesPartesBucais().map(
  (parteBucal) =>
    ({
      value: parteBucal,
      label: getTecidosMolesParteBucal(parteBucal).title,
    } as LocalTecidosMolesFieldModel)
)
